import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "256",
  height: "256",
  fill: "currentColor",
  viewBox: "0 0 200 200"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<path d=\"m34 80 20-50 16 42zM166 80l-20-50-16 42z\"></path><circle cx=\"100\" cy=\"110\" r=\"64\"></circle><ellipse cx=\"78\" cy=\"100\" fill=\"var(--mc-avatar)\" rx=\"8\" ry=\"10\"></ellipse><ellipse cx=\"122\" cy=\"100\" fill=\"var(--mc-avatar)\" rx=\"8\" ry=\"10\"></ellipse><path fill=\"var(--mc-avatar)\" d=\"M60 130q40 40 80 0h-10l-6 8-8-8-8 8-8-8-8 8-8-8-8 8-6-8Z\"></path>", 5)
  ]))]))
}
export default { render: render }